import { useEffect } from 'react';

export default function useTitle(title) {
  // Ensure we reset to previous title here.
  useEffect(() => {
    const originalTitle = document.title;
    return () => {
      document.title = originalTitle;
    };
  }, []);

  // Set the current title.
  useEffect(() => {
    if (title) document.title = title;
  }, [title]);
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/hooks/use_title.js